import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './router'
import './styles/overwirthe.css'


// Configuración global de Axios
// deb ser antes montar la appp o no funcionara la configuracion
import axios from 'axios';
axios.defaults.baseURL = 'http://localhost:8080/Bahiol-market/api';
axios.defaults.withCredentials = true;

loadFonts()

createApp(App).use(router)
  .use(vuetify)
  .mount('#app')

